import { render, staticRenderFns } from "./OrderSelect.vue?vue&type=template&id=0dab7552&"
import script from "./OrderSelect.vue?vue&type=script&lang=js&"
export * from "./OrderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports